(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b100-collection-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-collection-links')) {
    customElements.define('b100-collection-links', class extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('nav');
        this.links = [...this.nav.children];
        this.toggle = this.querySelector('button');
        this.expanded = false;
        this.controller = new AbortController();
        this.toggle.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.measure();
        }, { signal: this.controller.signal });
        this.observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === this.width) return;
          this.width = entry.contentRect.width;
          this.schedule();
        });
        this.observer.observe(this.nav);
        document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
        this.measure();
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      }
      measure() {
        this.links.forEach(link => { link.hidden = false; });
        let row = 0;
        let previousTop = -Infinity;
        const overflow = this.links.filter(link => {
          const top = link.getBoundingClientRect().top;
          if (Math.abs(top - previousTop) > 1) { row++; previousTop = top; }
          return row > 2;
        });
        this.toggle.hidden = overflow.length === 0;
        if (!this.expanded) {
          if (overflow.includes(document.activeElement)) this.toggle.focus({ preventScroll: true });
          overflow.forEach(link => { link.hidden = true; });
        }
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.querySelector('[data-toggle-label]').textContent = this.expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
        this.querySelector('[data-hidden-count]').textContent = this.expanded ? '' : `(+${overflow.length})`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b100-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-motion')) {
    customElements.define('b100-motion', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (!this.section || this.dataset.enabled !== 'true' || this.dataset.editor === 'true') return;
        this.controller = new AbortController();
        this.query = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
        const observe = () => {
          this.observer?.disconnect();
          if (!this.query.matches) return;
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.start();
            }
          }, { rootMargin: '240px' });
          this.observer.observe(this.section);
        };
        this.query.addEventListener('change', observe, { signal: this.controller.signal });
        observe();
      }
      async start() {
        if (this.media) return;
        const load = (url) => new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        });
        try {
          window.b100MotionReady ||= load(this.dataset.gsap).then(() => load(this.dataset.scroll));
          await window.b100MotionReady;
          if (!this.isConnected || this.media) return;
          const { gsap, ScrollTrigger } = window;
          gsap.registerPlugin(ScrollTrigger);
          this.media = gsap.matchMedia();
          this.media.add('(min-width: 990px) and (prefers-reduced-motion: no-preference)', () => {
            this.section.querySelectorAll('[data-b100-parallax]').forEach(layer => {
              gsap.fromTo(layer, { yPercent: -1.5, scale: 1.035 }, {
                yPercent: 1.5, scale: 1.035, ease: 'none',
                scrollTrigger: { trigger: layer.parentElement, start: 'top bottom', end: 'bottom top', scrub: .65 }
              });
            });
            this.section.querySelectorAll('[data-b100-drift]').forEach(element => {
              gsap.fromTo(element, { y: 14 }, {
                y: -8, ease: 'none',
                scrollTrigger: { trigger: this.section, start: 'top bottom', end: 'bottom top', scrub: .8 }
              });
            });
          }, this.section);
        } catch { /* Shopping content is fully usable without the motion library. */ }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.media?.revert();
        this.media = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b100-product-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-availability')) {
    customElements.define('b100-availability', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.closest('.js-product')?.addEventListener('on:variant:change', (event) => {
          const variant = event.detail.variant;
          this.dataset.available = String(!!variant?.available);
          this.querySelector('[data-availability-text]').textContent = !variant ? this.dataset.chooseLabel : variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b100-product-facts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-product-facts')) {
    customElements.define('b100-product-facts', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        document.addEventListener('on:variant:change', event => {
          if (String(event.detail.product.id) !== this.dataset.productId) return;
          const variant = event.detail.variant;
          for (const field of ['sku', 'barcode']) {
            this.querySelector(`[data-fact-value="${field}"]`).textContent = variant?.[field] || '';
            this.querySelector(`[data-fact-row="${field}"]`).hidden = !variant?.[field];
          }
          this.querySelectorAll('[data-option-value]').forEach(value => {
            value.textContent = variant?.options[Number(value.dataset.optionValue)] || '—';
          });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b100-product-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-detail-link')) {
    customElements.define('b100-detail-link', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          target.open = true;
          target.querySelector('summary')?.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["b100-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('b100-purchase-bar')) {
    customElements.define('b100-purchase-bar', class extends HTMLElement {
      connectedCallback() {
        this.section = document.getElementById(this.dataset.sectionId);
        this.form = document.getElementById(this.dataset.formId);
        this.original = this.form?.querySelector('[name="add"]');
        this.button = this.querySelector('button');
        if (!this.original) return;
        this.sync = () => {
          this.button.textContent = this.original.textContent.trim();
          this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
          const price = this.section.querySelector('.product-info__price .price__default:not([hidden]) .price__current')?.textContent.trim() || '';
          this.querySelector('.b100-purchase-bar__price').textContent = price;
          this.querySelector('.b100-purchase-bar__price').parentElement.hidden = !price;
          const rect = this.original.getBoundingClientRect();
          const header = document.querySelector('.cc-header--sticky');
          const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
          this.hidden = rect.bottom >= headerBottom || !this.original.getClientRects().length;
        };
        this.submit = () => {
          if (this.button.disabled) return;
          if (!this.form.checkValidity()) {
            this.form.querySelector(':invalid')?.closest('details')?.setAttribute('open', '');
            this.original.scrollIntoView({ block: 'center' });
          }
          this.form.requestSubmit(this.original);
        };
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.button.addEventListener('click', this.submit);
        this.intersection = new IntersectionObserver(this.sync);
        this.intersection.observe(this.original);
        this.mutations = new MutationObserver(this.sync);
        this.mutations.observe(this.original, { attributes: true, childList: true, subtree: true });
        const price = this.section.querySelector('.product-info__price');
        if (price) this.mutations.observe(price, { attributes: true, childList: true, subtree: true, characterData: true });
        this.sync();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        cancelAnimationFrame(this.frame);
        this.intersection?.disconnect();
        this.mutations?.disconnect();
        this.button?.removeEventListener('click', this.submit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
